import { Colors, WorkspaceSizeThresholds } from "@/common/constants";
import { interactionBarShadow } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexShrink: 0,
		minHeight: "60px",
		backgroundColor: tokens.colorNeutralBackground1,
		...shorthands.overflow("hidden"),
		margin: "0 1rem 0",
		...shorthands.borderRadius(tokens.borderRadiusMedium),
		...interactionBarShadow(),
		flexDirection: "row",
		width: "calc(100% - 32px)",

		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				flexDirection: "column",
			},
	},
	contactLabel: {
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Medium}px) and (width > 684px )`]:
			{
				maxWidth: "440px",
			},
		[`@container workspacePanel (width < 684px) and (width > ${WorkspaceSizeThresholds.Small}px)`]:
			{
				maxWidth: "380px",
			},
		[`@container workspacePanel (width < ${WorkspaceSizeThresholds.Small}px) and (width > 472px )`]:
			{
				maxWidth: "320px",
			},
		"@container workspacePanel (width < 472px)": {
			maxWidth: "260px",
		},
	},
	divider: {
		minHeight: "3.75rem",
		flexGrow: 0,

		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				display: "none",
			},
	},
	leftContainer: {
		padding: "5px 16px 10px 16px",
		flexShrink: 1,
		...shorthands.overflow("hidden"),
		width: "100%",
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				alignSelf: "flex-start",
			},
	},
	rightContainer: {
		width: "100%",
		padding: "16px 16px 10px 16px",
		...shorthands.overflow("hidden"),
	},
	icon: {
		color: tokens.colorNeutralForeground3,
		flexShrink: 0,
	},
	// Same green and label colour as the Pickup button (Colors.ButtonGreenBackground) — the two are
	// the app's only "start this interaction" affirmatives and were drifting apart on two different
	// palettes. Pickup is a Fluent Button appearance="primary", and that appearance supplies
	// colorNeutralForegroundOnBrand (#ffffff in both themes); its customPaddingButton class overrides
	// only the background, so white is what Pickup actually renders on this green.
	//
	// White on #6BB700 is ~2.5:1, below WCAG AA. That is a property of the brand green and is shared
	// with Pickup, so darkening this label alone would only put the two back out of step — the green
	// itself is the thing to revisit.
	initCallButton: {
		...shorthands.border(0),
		...shorthands.borderRadius(tokens.borderRadiusMedium),
		backgroundColor: Colors.ButtonGreenBackground,
		color: tokens.colorNeutralForegroundOnBrand,
		minWidth: "48px",
		minHeight: "32px",
		cursor: "pointer",
		width: "100%",
		":disabled": {
			backgroundColor: tokens.colorNeutralStroke1Hover,
		},
		":disabled:hover": {
			backgroundColor: tokens.colorNeutralStroke1,
			cursor: "default",
		},
		"&:hover": {
			backgroundColor: Colors.ButtonGreenBackgroundHover,
		},
		"&:active": {
			backgroundColor: Colors.ButtonGreenBackgroundHover,
		},
	},
	selectTrigger: {
		width: "100%",
		[`@container workspacePanel (width > ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				maxWidth: "unset !important",
			},
	},
	selectContainer: {
		width: "100%",
		backgroundColor: tokens.colorNeutralBackground1Hover,
		padding: "3px 6px",
	},
	closeButton: {
		position: "absolute",
		top: "9px",
		right: "12px",
	},
	multiInput: {
		width: "100%",
	},
	multiInputInvalid: {
		border: `1px solid ${tokens.colorPaletteRedBorder1}`,
	},
	multiInputContainer: {
		width: "100%",
		padding: "0px 0px 0px 6px",
		backgroundColor: tokens.colorNeutralBackground1Hover,
	},
	dialpad: {
		cursor: "pointer",
	},
	multiInputElement: {
		width: "100%",
		backgroundColor: tokens.colorNeutralBackground1Hover,
		"&:focus-within": {
			outline: "none",
			boxShadow: "none",
		},
	},
	callButtonContainer: {
		width: "100%",
		padding: "0px 16px 20px 16px",
	},
	callButtonIconContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	callButtonIcon: {
		marginRight: "6px",
	},
	menuPopoverOutbound: {
		overflowY: "scroll",
		maxWidth: "unset",
		width: "400px",
		maxHeight: "calc(100vh - 200px)",
	},
});
